<template>
    <div class="componentWrapper">
        <div class="imageContainer">
            <img 
                class="coverImg" 
                :src="require('@/assets/vegotarLong.png')" 
            >
        </div>
        <div class="sellerInfo">
            <div class="flexSides">
                <div>
                    <span>Reg. 14368904</span>
                    <h1>Vegotar Tööstusautomaatika OÜ</h1>
                    <p><i class="pi pi-map-marker"></i> Linaski Rannaküla, Elva vald, 61012 Tartumaa</p>
                    <!-- <p>KMnr. EE102024434</p> -->
                     <p><i class="pi pi-phone"></i>+372 523 7371</p>
                    <Button 
                        :label="$t('buttons.contactUs', currentLang)" 
                        @click="$emit('openContactPopup')" 
                        icon="pi pi-envelope" 
                        severity="contrast" 
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';

export default {
    name: 'sellerCard',
    components: {
        Button
    },
    props: {
        fetchDataListing: {
            required: true
        },
        shopData: {
            required: true
        },
    },
    data() {
        return {
        }
    },

    methods: {
    },
}
</script>

<style scoped>
.componentWrapper{
    width: 100%;
    position: relative;
    height: 240px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.imageContainer {
    top: 25px;
    position: absolute;
    z-index: 1;
    border: 1px solid rgb(235,235,235);
    padding-top: 35px;
    padding-bottom: 35px;
    padding-left: 15px;
    padding-right: 15px;
    background: white;
    background: rgb(255,255,255);
    border-radius: 30px;
    /* box-shadow: 4px 13px 30px 1px rgba(0, 0, 0, 0.2); */
}
.imageContainer img {
    width: 200px;
    opacity: .8;
}
.sellerInfo {
    position: relative;
    width: 90%;
    margin-left: auto;
    background: rgb(245,245,245);
    border-radius: 20px;
    /* -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2); */
}
.flexSides {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 200px;
    padding-top: 25px;
}
.flexSides p {
    margin: 0;
    margin-bottom: 15px;
    word-wrap: break-word;
    color: rgb(150,150,150);
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
    font-weight: 600;
    font-size: 14px;
}
.flexSides h1 {
    font-size: 22px;
    margin: 0;
    margin-top: 5px;
    margin-bottom: 15px;
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
}
.flexSides span {
    margin: 0;
    word-wrap: break-word;
    color: rgb(175,175,175);
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
    font-weight: 600;
    font-size: 14px;

}
.flexSides img {
    margin-top: -15px;
}
.flexSides button {
    margin-top: 0px;
}
.flexSides i {
    margin-right: 7px;
}

@media (max-width: 1100px) {
    .componentWrapper{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
    .imageContainer {
        top: -50px;
        right: 0;
        margin:  auto;
        position: absolute;
        z-index: 1;
        border: 1px solid rgb(235,235,235);
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 25px;
        padding-right: 15px;
        width: 260px;
        background: white;
        background: rgb(255,255,255);
        border-radius: 30px;
        /* box-shadow: 4px 13px 30px 1px rgba(0, 0, 0, 0.2); */
    }
    .imageContainer img {
        width: 200px;
        opacity: .8;
    }
    .sellerInfo {
        position: relative;
        width: 100%;
        margin-left: auto;
        border-radius: 20px 20px 20px 20px;
        margin-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 35px;
        padding-bottom: 30px;
    }
    .flexSides {
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        padding-left: 0px;
        padding-top: 25px;
    }
}
@media (max-width: 800px) {
    .componentWrapper{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        margin-top: 50px;
        margin-bottom: 50px;
    }
}
@media (max-width: 420px) {
    .sellerInfo {
        padding-top: 55px;
        padding-bottom: 50px;
    }
    .imageContainer {
        left: 0;
    }
    button {
        width: 100%;
    }
}
</style>
    